import { render, staticRenderFns } from "./CustomerOrderReplicaTable.vue?vue&type=template&id=033c7798&scoped=true"
import script from "./CustomerOrderReplicaTable.vue?vue&type=script&lang=js"
export * from "./CustomerOrderReplicaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c7798",
  null
  
)

export default component.exports